import {
    createAction,
    createAsyncThunk,
    createSlice,
    PrepareAction,
  } from "@reduxjs/toolkit";
  import { readUser, persistUser } from "../../services/localStorage.Service";
  import {
    User,
    UserModel,
    UserWithProjects,
  } from "../../domaine/userModel";
  import {
    addUserApi,
    deleteUserApi,
    fetchUsersApi,
    fetchUsersWithProjectsApi,
    updateUserApi,
    UserBody,
  } from "../../api/users.api";
import { Dashboard } from "../../domaine/dashboardModel";
import { fetchDashboardApi } from "../../api/dashboard.api";
  
  export interface DashboardState {
   data:Dashboard|null;
    loading: "idle" | "pending" | "succeeded" | "failed";
  }
  
  const initialState: DashboardState = {
    data: null,  
    loading: "idle",
  };
  
  const API_URL = "dashboard/";
  
  
  
  export const fetchDashboard: any = createAsyncThunk(
    "Dashboard/fetchDashboard",
    async () => {
      const projects: Dashboard = await fetchDashboardApi(API_URL);
      return projects;
    }
  );
  
  
  
  export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchDashboard.pending, (state) => {
          state.loading = "pending";
        })
        .addCase(fetchDashboard.fulfilled, (state, action) => {
          state.loading = "succeeded";
          state.data = action.payload;
        })
        .addCase(fetchDashboard.rejected, (state) => {
          state.loading = "failed";
        })
        ;
    },
  });
  

  
  export default dashboardSlice.reducer;
  